import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-column-box work-manage-detail-digitalman flex-start" }
const _hoisted_2 = { class: "flex-column-box wrap radius-middle flex-start" }
const _hoisted_3 = { class: "flex-row-box info-wrap flex-start" }
const _hoisted_4 = { class: "demo-info" }
const _hoisted_5 = { class: "info-list" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "flex-row-box flex-start" }
const _hoisted_12 = { style: {"margin":"0px"} }
const _hoisted_13 = { class: "flex-row-box timer-wrap flex-start" }
const _hoisted_14 = { class: "opt-btn-wrap" }

import {ref, onMounted, computed} from 'vue';
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'digitalManDetail',
  props: {},
  setup(__props) {

const router = useRouter();
const props = __props

const info = ref({
  name: '小娥',
  taskType: '通用口型',
  createTime: '2023-08-12 12:12:12',
  gender: '女',
  materiral: '形象定制.mp4',
  matting: false,
  authMaterirals: [
    '形象定制.mp4',
    '授权材料.pdf'
  ],
  status: 3
})

const timer = ref([
  {
    label:'素材提交成功',
    time: '11-13 14:25',
    status: 1
  },{
    label:'审核不通过',
    time: '11-14 14:25',
    status: 2,
    errorReason: '失败原因失败原因'
  },{
    label:'智能训练完成',
    time: '11-15 14:25',
    status: 0
  },{
    label:'效果确认通过',
    time: '11-16 14:25',
    status: 0
  },{
    label:'完成',
    time: '11-17 14:25',
    status: 0
  }
])

const goBack = ()=>{
  router.go(-1);
}

const gotoConfirm = ()=>{
  router.push({
    name: 'DigitalmanEffect'
  })
}


onMounted(()=>{

})


return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "flex-row-box header-box",
      onClick: goBack
    }, [
      _createVNode(_component_svgIcon, { iconClass: "arrowleft" }),
      _cache[0] || (_cache[0] = _createTextVNode("我的定制形象 "))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "demo-video" }, [
          _createElementVNode("video", {
            src: "",
            style: {"width":"100%","height":"100%"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "小娥", -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_6, "任务ID：" + _toDisplayString(info.value.name), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_7, "任务类型： " + _toDisplayString(info.value.taskType), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_8, "创建时间：" + _toDisplayString(info.value.createTime), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_9, "性别：" + _toDisplayString(info.value.gender), 1)
            ]),
            _createElementVNode("li", null, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text" }, "原始素材：", -1)),
              _createElementVNode("a", null, _toDisplayString(info.value.materiral), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_10, "视频抠绿：" + _toDisplayString(info.value.matting?'需去背景':'无需去背景'), 1)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text" }, "授权材料：", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.authMaterirals, (item) => {
                  return (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(item), 1))
                }), 256))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timer.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.status==2)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  "popper-class": "error-popper",
                  placement: "top-start",
                  title: "失败原因",
                  width: 200,
                  trigger: "hover",
                  content: item.errorReason
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex-column-box timer-item", item.status==1 ? 'completed' : item.status==2 ? 'error' : 'waite'])
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.label), 1),
                      _createElementVNode("p", null, _toDisplayString(item.time), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["content"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["flex-column-box timer-item", item.status==1 ? 'completed' : item.status==2 ? 'error' : 'waite'])
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.label), 1),
                  _createElementVNode("p", null, _toDisplayString(item.time), 1)
                ], 2))
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        (info.value.status==1)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("查看demo")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (info.value.status==2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("重新提交")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (info.value.status==3)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              plain: "",
              onClick: gotoConfirm
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("去确认")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})